import { useMemo } from "react";
import { motion, useReducedMotion } from "framer-motion";

type Msg = { user: string; text: string; color: string };

const POOL: Msg[] = [
  { user: "Mordeczka123", text: "karp powiedz cos brzydkiego", color: "#E11D48" },
  { user: "JanuszCzajkowski", text: "5 zlotych ostatnie ze stypy", color: "#2563EB" },
  { user: "BLIK_ENJOYER", text: "wpalam stowke i niech jedzie z koksem", color: "#FACC15" },
  { user: "ksiezyc_w_lufie", text: "karp to mistrz", color: "#84CC16" },
  { user: "P R Z E G I E T", text: "DAJ MONOLOG ZA 10 TYSI", color: "#22D3EE" },
  { user: "CichaWoda", text: "regulamin? ja mam regulamin: zaplacic i sluchac", color: "#FB7185" },
  { user: "polibuda_2026", text: "wreszcie sztuka uzytkowa", color: "#A855F7" },
  { user: "korba_lyse", text: "moja babcia by go pokochala albo zabila", color: "#F97316" },
  { user: "BezNicku42", text: "KARPIU DAJ ZNAK ZE ZYJESZ", color: "#06B6D4" },
  { user: "smutny_andrzej", text: "moje BLIK pinki za kawe poszly na karpia", color: "#EC4899" },
  { user: "lukasz_z_wroclaw", text: "lepsze niz terapeuta", color: "#10B981" },
  { user: "stara_szkola", text: "ku@^ ile mozna sie smiac", color: "#8B5CF6" },
];

type Props = {
  /** number of "lanes" sliding across the screen */
  lanes?: number;
  className?: string;
};

/**
 * Decorative chat overlay — fake stream chat sliding across the background.
 * Pure cosmetic; aria-hidden, paused on reduced-motion.
 */
export function ChatOverlay({ lanes = 6, className }: Props) {
  const reduced = useReducedMotion();
  const items = useMemo(() => {
    const arr: (Msg & { lane: number; delay: number; dur: number; size: number })[] = [];
    for (let i = 0; i < lanes; i++) {
      const m = POOL[i % POOL.length];
      arr.push({
        ...m,
        lane: i,
        delay: i * 1.4,
        dur: 14 + (i % 3) * 4,
        size: 0.85 + ((i * 13) % 5) * 0.06,
      });
      const m2 = POOL[(i + 5) % POOL.length];
      arr.push({
        ...m2,
        lane: i,
        delay: i * 1.4 + 7,
        dur: 14 + (i % 3) * 4,
        size: 0.85 + ((i * 7) % 5) * 0.06,
      });
    }
    return arr;
  }, [lanes]);

  if (reduced) return null;

  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className || ""}`}
    >
      {items.map((it, idx) => (
        <motion.div
          key={idx}
          initial={{ x: "-30vw" }}
          animate={{ x: "110vw" }}
          transition={{
            duration: it.dur,
            delay: it.delay,
            repeat: Infinity,
            ease: "linear",
          }}
          style={{
            top: `${(it.lane * 100) / lanes + 4}%`,
            fontSize: `${it.size}rem`,
          }}
          className="absolute whitespace-nowrap font-mono opacity-25 select-none"
        >
          <span style={{ color: it.color, fontWeight: 700 }}>{it.user}: </span>
          <span className="text-carp-ink">{it.text}</span>
        </motion.div>
      ))}
    </div>
  );
}

export default ChatOverlay;
